<template>
  <span
    v-if="label"
    class="br-status-badge"
    :class="`br-status-badge--${variant}`"
  >
    <img
      v-if="iconUrl"
      :src="iconUrl"
      class="br-status-badge__icon"
      width="12"
      height="12"
      alt=""
    />
    <span class="br-status-badge__text">{{ label }}</span>
  </span>
</template>

<script>
import { BR_LICENSE_ASSETS } from "../../../constants/brLicenseAssets";
import { BR_STATUS, BR_STATUS_LABEL_KEY } from "../utils/brDocument";

const VARIANT_MAP = {
  [BR_STATUS.NOT_YET_EFFECTIVE]: {
    iconUrl: BR_LICENSE_ASSETS.badgeReady,
  },
  [BR_STATUS.APPROVED]: {
    iconUrl: BR_LICENSE_ASSETS.badgeApproved,
  },
  [BR_STATUS.READY]: {
    iconUrl: BR_LICENSE_ASSETS.badgeApproved,
  },
  [BR_STATUS.PENDING]: {
    /** 供應商 / 管理端「審批中」均為藍底 */
    iconUrl: BR_LICENSE_ASSETS.badgeReady,
  },
  [BR_STATUS.PENDING_MANUAL]: {
    /** 供應商：藍；管理端「人工審批中」：黃（adminIconUrl） */
    iconUrl: BR_LICENSE_ASSETS.badgeReady,
    adminIconUrl: BR_LICENSE_ASSETS.badgePending,
  },
  [BR_STATUS.REJECTED]: {
    iconUrl: BR_LICENSE_ASSETS.badgeStatusAlert,
  },
  [BR_STATUS.CANCELLED]: {
    iconUrl: BR_LICENSE_ASSETS.badgeStatusAlert,
  },
  [BR_STATUS.INVALID]: {
    iconUrl: BR_LICENSE_ASSETS.badgeStatusAlert,
  },
};

export default {
  name: "BrStatusBadge",
  props: {
    statusCode: {
      type: String,
      default: "",
    },
    statusName: {
      type: String,
      default: "",
    },
    /** 可選：覆蓋默認文案 key（管理端 P/PA 區分） */
    labelKey: {
      type: String,
      default: "",
    },
    /**
     * supplier | approval | edit | admin
     * Macy：管理端僅「人工審批中」黃色；「審批中」與供應商端均為藍色
     */
    appearance: {
      type: String,
      default: "supplier",
      validator: (value) =>
        ["supplier", "edit", "approval", "admin"].includes(value),
    },
  },
  computed: {
    normalizedCode() {
      return (this.statusCode || "").toUpperCase();
    },
    isAdminAppearance() {
      const a = this.appearance;
      return a === "approval" || a === "edit" || a === "admin";
    },
    /** 管理端「人工審批中」黃底；其餘待審（含管理端審批中、供應商兩種）藍底 */
    isAdminManualPendingTone() {
      return (
        this.isAdminAppearance &&
        this.normalizedCode === BR_STATUS.PENDING_MANUAL
      );
    },
    variant() {
      if (this.normalizedCode === BR_STATUS.NOT_YET_EFFECTIVE) {
        return "not-yet-effective";
      }
      if (this.normalizedCode === BR_STATUS.INVALID) {
        return "invalid";
      }
      if (
        this.normalizedCode === BR_STATUS.READY ||
        this.normalizedCode === BR_STATUS.APPROVED
      ) {
        return "approved";
      }
      if (this.normalizedCode === BR_STATUS.PENDING) {
        return "pending";
      }
      if (this.normalizedCode === BR_STATUS.PENDING_MANUAL) {
        return this.isAdminManualPendingTone ? "pending-admin" : "pending";
      }
      if (this.normalizedCode === BR_STATUS.REJECTED) {
        return "rejected";
      }
      if (this.normalizedCode === BR_STATUS.CANCELLED) {
        return "cancelled";
      }
      return "unknown";
    },
    iconUrl() {
      const map = VARIANT_MAP[this.normalizedCode];
      if (!map) {
        return "";
      }
      if (this.isAdminManualPendingTone && map.adminIconUrl) {
        return map.adminIconUrl;
      }
      return map.iconUrl || "";
    },
    label() {
      const key = this.labelKey || BR_STATUS_LABEL_KEY[this.normalizedCode];
      if (key) {
        const text = this.$t(key);
        return text == null ? "" : String(text).trim();
      }
      return this.statusName || this.statusCode || "";
    },
  },
};
</script>
